
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guiabroker",
      function () {
        return require("private-next-pages/guiabroker/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guiabroker"])
      });
    }
  